export default {
      id: "address-location-usage",
      viewBox: "0 0 14 20",
      url: __webpack_public_path__ + "img/icons.svg#address-location",
      toString: function () {
        return this.url;
      }
    }